import React, { useMemo } from "react";
import { GlobalButton } from "../../../../../global/forms/GlobalFormFields";
import GlobalBadge from "../../../../../global/GlobalBadge";
import GlobalDirectoryGridSection from "../../../../../global/directory/GlobalDirectoryGridSection";
import { GlobalDirectoryPaginationSection } from "../../../../../global/directory";
import {
  RENEWAL_LIST_COLUMN_DEFS,
  calcRenewalAmount,
  formatDateCell,
  formatMoney,
  isTruthy,
} from "../membershipRenewCommon";

export default function MembershipRenewListDirectorySection({
  loading,
  sortedRows,
  columnVisibility,
  sortColumn,
  sortOrder,
  onSortColumnChange,
  onSortOrderToggle,
  onRenewalClick,
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
  onScrollToHistory,
}) {
  const visibleColumns = useMemo(
    () => RENEWAL_LIST_COLUMN_DEFS.filter((c) => columnVisibility[c.id]),
    [columnVisibility],
  );

  const tableHeaders = useMemo(
    () => [
      ...visibleColumns.map((c) => ({
        key: c.id,
        label: c.sortable ? (
          <button
            type="button"
            className="vpart-sort-btn"
            onClick={() => {
              if (sortColumn === c.id) onSortOrderToggle();
              else {
                onSortColumnChange(c.id);
              }
            }}
          >
            {c.label}
            {sortColumn === c.id ? (
              <span className="vpart-sort-ind">{sortOrder === "ASC" ? "▲" : "▼"}</span>
            ) : null}
          </button>
        ) : (
          c.label
        ),
      })),
      { key: "actions", label: "Actions", className: "vt-col-actions" },
    ],
    [visibleColumns, sortColumn, sortOrder, onSortColumnChange, onSortOrderToggle],
  );

  const isEmpty = !loading && sortedRows.length === 0;

  return (
    <div className="vml-renew-table-col">
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "0.6rem" }}>
        <GlobalButton type="button" variant="ghost" size="sm" onClick={onScrollToHistory}>
          Go to Renewal History
        </GlobalButton>
      </div>
      <GlobalDirectoryGridSection
        loading={loading}
        loadingMessage="Loading memberships…"
        headers={tableHeaders}
        isEmpty={isEmpty}
        emptyMessage="No memberships available for renewal."
        tableAriaLabel="Volunteer membership renewals list"
        wrapClassName="vt-table-wrap"
        tableClassName="vt-table"
      >
        {!loading && sortedRows.length > 0
          ? sortedRows.map((row) => (
              <tr key={row.application_id}>
                {visibleColumns.map((c) => (
                  <td key={c.id}>
                    {c.id === "application_verified" || c.id === "payment_verified" ? (
                      <GlobalBadge
                        active={isTruthy(row[c.id])}
                        activeText="Verified"
                        inactiveText="Not verified"
                      />
                    ) : c.id === "amount" ? (
                      formatMoney(calcRenewalAmount(row))
                    ) : c.id === "start_date" || c.id === "end_date" ? (
                      formatDateCell(row[c.id])
                    ) : c.id === "submitted_at" ? (
                      formatDateCell(row.submitted_at, true)
                    ) : (
                      row[c.id] ?? "—"
                    )}
                  </td>
                ))}
                <td className="vt-col-actions">
                  <div className="vt-actions">
                    <GlobalButton type="button" variant="ghost" size="sm" onClick={() => onRenewalClick(row)}>
                      Renewal
                    </GlobalButton>
                  </div>
                </td>
              </tr>
            ))
          : null}
      </GlobalDirectoryGridSection>
      <GlobalDirectoryPaginationSection
        page={page}
        totalPages={totalPages}
        total={total}
        pageSize={pageSize}
        onPageChange={onPageChange}
        label="Membership renewals pagination"
      />
    </div>
  );
}
